import { openDB } from "idb";
import { CATEGORY_LAYOUT_DB_NAME, CATEGORY_LAYOUT_STORE } from "./constants";

export const dbPromise = openDB(CATEGORY_LAYOUT_DB_NAME, 1, {
  upgrade(db) {
    if (!db.objectStoreNames.contains(CATEGORY_LAYOUT_STORE)) {
      db.createObjectStore(CATEGORY_LAYOUT_STORE);
    }
  },
});

export async function saveLayout(key, value) {
  const db = await dbPromise;
  await db.put(CATEGORY_LAYOUT_STORE, value, key);
}

export async function getLayout(key) {
  const db = await dbPromise;
  return db.get(CATEGORY_LAYOUT_STORE, key);
}
